import Loader from "../../../components/loader";
import PublicPageStyles from "./shared/PublicPageStyles";
import SimulationCard from "./shared/SimulationCard";
import SimulationLibrarySidebar from "./shared/SimulationLibrarySidebar";
import useSimulationLibrary from "./shared/useSimulationLibrary";
import "./PublicSimulationPage.css";

const PublicSimulationPage = () => {
  const {
    sims,
    loading,
    loadingMore,
    search,
    selectedFilters,
    isShowLastTwelveMonths,
    filterOptions,
    handleSearchInput,
    handleSearch,
    handleFilterClick,
    handleChangeLastMonth,
  } = useSimulationLibrary();

  return (
    <div className="public-simulation-page page-template page-template-list page-template-list-php page-id-54 wp-custom-logo wp-embed-responsive group-blog">
      <PublicPageStyles />

      <div className="site" id="page">
        <div className="wrapper">
          <section className="simulation-header p-0">
            <h3 className="title">Simulation Library</h3>
          </section>
          <section className="simulations-section p-0">
            <SimulationLibrarySidebar
              filterOptions={filterOptions}
              selectedFilters={selectedFilters}
              search={search}
              isShowLastTwelveMonths={isShowLastTwelveMonths}
              onSearchInput={handleSearchInput}
              onSearch={handleSearch}
              onFilterClick={handleFilterClick}
              onChangeLastMonth={handleChangeLastMonth}
            />
            <div className="simulations">
              {sims.length < 1 && !loading ? (
                <h3 className="title">No simulation exist.</h3>
              ) : (
                sims.map((data) => (
                  <SimulationCard
                    key={data.simId}
                    data={data}
                    detailPath={(simId) => `/simulation/${simId}`}
                    showDownloadOverviews={true}
                  />
                ))
              )}
              {loadingMore && (
                <div className="overlay">
                  <Loader loading={true} />
                </div>
              )}
            </div>
          </section>
        </div>

        {loading && (
          <div className="overlay">
            <Loader loading={loading} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicSimulationPage;
